import { useMemo } from "react";
import { useMergedCalendarEvents } from "./useMergedCalendarEvents";
import { deriveSummary, groupEvents, type CalendarSummary } from "./homeCalendar";
import { type CalendarEvent, type EventGroup } from "./types";

const DEFAULT_HORIZON_DAYS = 60;

export const useHomeCalendar = (
    horizonDays: number = DEFAULT_HORIZON_DAYS,
): { groups: Record<EventGroup, CalendarEvent[]>; summary: CalendarSummary; total: number } => {
    // SP1 derived+user merge, SP3 per-item state overlay (design spec
    // §III.7) - factored out to useMergedCalendarEvents.ts (SP4) so the
    // dedicated calendar page shares the exact same pipeline.
    const events = useMergedCalendarEvents();
    return useMemo(() => {
        const today = new Date();
        // Done items stay in their group, struck through (§III.11 decision #4) -
        // but are excluded from the summary/badge count via `activeEvents`.
        const groups = groupEvents(events, today, horizonDays);
        const activeEvents = events.filter((e) => !e.done);
        const total = (Object.values(groups) as CalendarEvent[][]).reduce((n, g) => n + g.length, 0);
        return { groups, summary: deriveSummary(activeEvents, today), total };
    }, [events, horizonDays]);
};
